import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});

const transferRows = [
  {
    id: 1,
    tId: 1,
    transdate: "5/5/2025",
    communicationtype: "SMS",
    inwardtype: "Transferred",
    count: "70",
    remarks: "Test",
  },
  {
    id: 2,
    tId: 2,
    transdate: "5/5/2025",
    communicationtype: "Whatsapp",
    inwardtype: "Reversal",
    count: "52",
    remarks: "Test",
  },
];

const transferColumns = [
  { field: "id", headerName: "S.No", width: 70, sortable: false },
  { field: "tId", headerName: "Transfer ID", width: 70, sortable: false },
  { field: "transdate", headerName: "Transfer Date", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 180 },
  { field: "inwardtype", headerName: "Inward Type", width: 180 },
  { field: "count", headerName: "Transfer Count", width: 150 },
  { field: "remarks", headerName: "Remarks", width: 150 },
];

const reverseRows = [
  {
    id: 1,
    tId: 1,
    reversedate: "5/5/2025",
    communicationtype: "SMS",
    inwardtype: "Transferred",
    reversecount: "70",
    remarks: "Test",
  },
  {
    id: 2,
    tId: 2,
    reversedate: "5/5/2025",
    communicationtype: "Whatsapp",
    inwardtype: "Reversal",
    reversecount: "52",
    remarks: "Test",
  },
];

const reverseColumns = [
  { field: "id", headerName: "S.No", width: 70, sortable: false },
  { field: "tId", headerName: "Reversal ID", width: 70, sortable: false },
  { field: "reversedate", headerName: "Reversal Date", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 180 },
  { field: "inwardtype", headerName: "Inward Type", width: 180 },
  { field: "reversecount", headerName: "Reversal Count", width: 150 },
  { field: "remarks", headerName: "Remarks", width: 150 },
];

const VendorList = () => {
  const classes = useStyles();
  const [type, setType] = React.useState("");
  const [filterBy, setFilterBy] = React.useState("");

  return (
    <>
      <Card elevation={3} sx={{ marginBottom: "15px" }}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="communication-type-label">
                Communication Type
              </InputLabel>
              <Select
                labelId="communication-type-label"
                id="communication-type-select"
                label="Communication Type"
              >
                <MenuItem value="sms">SMS</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="whatsapp">Whatsapp</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="type-select-label">Inward Type</InputLabel>
              <Select
                labelId="type-select-label"
                id="type-select"
                value={type}
                label="Inward Type"
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="transfer">Transferred</MenuItem>
                <MenuItem value="reverse">Reversal</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="filter-by-label">Filter By</InputLabel>
              <Select
                labelId="filter-by-label"
                id="filter-by"
                value={filterBy}
                label="Filter By"
                onChange={(e) => setFilterBy(e.target.value)}
              >
                <MenuItem value="trans">Transfer</MenuItem>
                <MenuItem value="revers">Reversed</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {filterBy === "trans" && (
            <>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Transfer Valid From"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Transfer Valid To"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}

          {filterBy === "revers" && (
            <>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Reversed Valid From"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Reversed Valid To"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}
        </Grid>

        <Box className={classes.buttonContainer}>
          <Button
            variant="outlined"
            onClick={() => {
              setType("");
              setFilterBy("");
            }}
          >
            Reset
          </Button>
          <Button className={classes.animatedButton} variant="contained">
            Search
          </Button>
        </Box>
      </Card>

      {type && (
        <Card elevation={3}>
          <DataGrid
            rows={type === "transfer" ? transferRows : reverseRows}
            columns={type === "transfer" ? transferColumns : reverseColumns}
            pageSize={5}
            autoHeight
            disableSelectionOnClick
          />
        </Card>
      )}
    </>
  );
};

export default VendorList;
